// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xWyOCp {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: var(--spacing-3);
  padding: var(--spacing-3);
  flex: 1;
}

.gj6_Cm {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: var(--spacing-3);
  flex: 1;
}

.x9Aeol {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--type-subtitle-md-font-size);
  line-height: var(--type-subtitle-md-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
}

.H_vito {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  width: 100%;
}

.hCZeTA {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  align-self: stretch;
  gap: var(--spacing-1-5);
  padding: var(--spacing-3);
  background: var(--surface-neutral-white);
}

/* Responsive: Tablet e Mobile (até 1023px) */
@media (max-width: 1023px) {
  .hCZeTA {
    flex-direction: column;
    gap: var(--spacing-2);
  }

  .hCZeTA button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/DepositBilletSteps/ValueStep/ValueStep.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,4CAA4C;EAC5C,gDAAgD;EAChD,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA,6CAA6C;AAC7C;EACE;IACE,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3);\n  flex: 1;\n}\n\n.contentContainer {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: var(--spacing-3);\n  flex: 1;\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--type-subtitle-md-font-size);\n  line-height: var(--type-subtitle-md-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.inputContainer {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  width: 100%;\n}\n\n.buttonsContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  align-self: stretch;\n  gap: var(--spacing-1-5);\n  padding: var(--spacing-3);\n  background: var(--surface-neutral-white);\n}\n\n/* Responsive: Tablet e Mobile (até 1023px) */\n@media (max-width: 1023px) {\n  .buttonsContainer {\n    flex-direction: column;\n    gap: var(--spacing-2);\n  }\n\n  .buttonsContainer button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `xWyOCp`,
	"contentContainer": `gj6_Cm`,
	"title": `x9Aeol`,
	"inputContainer": `H_vito`,
	"buttonsContainer": `hCZeTA`
};
module.exports = ___CSS_LOADER_EXPORT___;
